import { useEffect } from 'react';

const useEnterKeyListener = ({ querySelectorToExecuteClick, deps = [] }) => {
  const handlePressEnter = () => {
    const element = document.querySelector(querySelectorToExecuteClick);

    if (element) {
      element?.click(); // Trigger a click event on the selected element
    }
  };

  useEffect(() => {
    const listener = (event) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        querySelectorToExecuteClick && handlePressEnter();
      }
    };

    document.addEventListener('keydown', listener);

    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [querySelectorToExecuteClick, ...deps]);
};

export default useEnterKeyListener;
